import React from "react";
import "./PolicyPage.css";

const ReturnPolicy = () => {
  return (
    <div className="policy-container">
      <pre className="policy-text">
        <h1>RETURN & REPLACEMENT POLICY</h1>
{`1. Eligibility for Return
Returns are accepted only in case of manufacturing defects, leakage, or incorrect dispatch.
Issues must be reported within 48 hours of product delivery, along with clear photo or video proof.
The product must be returned in its original packaging, unused, and with all seals intact.

2. Condition of Packaging & Seal
Products with a broken, tampered, or opened seal will not be accepted for return or replacement without prior written approval from Team Recla.
Once the seal is broken, the product will be considered as used, and any claim will be subject to inspection and verification by Recla’s technical team.
Customers must contact Recla before opening or testing the cartridge if there are visible defects or packaging damage.

3. Return Procedure
To initiate a return, customers must:
Email support@recla.in or contact their Recla sales representative within 48 hours of receipt.
Provide order number, photos/videos of the product and packaging, and a short description of the issue.
Await confirmation and return authorisation from Team Recla before shipping the item back.
Unauthorised returns or shipments sent without confirmation will not be accepted or refunded.

4. Replacement Terms
Approved returns will be inspected upon receipt.
If verified as a manufacturing defect, a replacement product or credit note will be issued within 7–10 business days.
If the product is found to be used, damaged due to improper handling, or incompatible with the printer, no replacement will be provided.

5. Non-Returnable Items
Products with broken seals without authorisation
Used or installed cartridges
Products damaged due to mishandling, improper storage, or third-party repair attempts
Bulk or customised orders, unless defective on arrival`}
      </pre>
    </div>
  );
};

export default ReturnPolicy;
